<template>
  <a-spin :spinning="pageLoading">
    <div class="head-btn">
      <a-button @click="login()" style="margin-right: 16px"> 直接登录 </a-button>
      <a-button @click="$router.push(`/projectImpl/pMechanism/updateMechanism?id=${$route.query.id}`)" type="primary"> 编辑机构 </a-button>
    </div>
    <a-card>
      <a-tabs v-model="tabActive" @change="tabChange">
        <a-tab-pane :key="index" :tab="item.name" v-for="(item, index) in tabs" />
      </a-tabs>
        <keep-alive>
            <component v-if="!pageLoading" :key="tabActive" :is="tabs[tabActive].component" />
        </keep-alive>
    </a-card>
  </a-spin>
</template>

<script>
import $Bus from '@/pages/projectImpl/js/eventBus'

export default {
  name: 'orgDetails',
  data() {
    return {
      pageLoading: true,
      orgInfo: {},
      tabActive: Number(this.$route.query.tabActive) || 0,
      tabs: [
        {
          name: '测评资源',
          component: () => import('@/pages/projectImpl/orgManage/childPages/CourseResource.vue'),
        },
        {
          name: '训练资源',
          component: () => import('@/pages/projectImpl/orgManage/childPages/CourseResource.vue'),
        },
        {
          name: '活动资源',
          component: () => import('@/pages/projectImpl/orgManage/childPages/CourseResource.vue'),
        },
        {
          name: '教学资源',
          component: () => import('@/pages/projectImpl/orgManage/childPages/TeachResources.vue'),
        },
      ],
    }
  },
  mounted() {
    this.getOrganizationInfo()
  },
  methods: {
    tabChange(index) {
      this.$router.push({
        query: {
          ...this.$route.query,
          tabActive: this.tabActive,
        },
      })
      $Bus.$emit('pageHeaderTitle', this.orgInfo.name)
    },
    getOrganizationInfo() {
      this.pageLoading = true
      this.$http.UserManage.getOrganizationInfo({
        organizationId: this.$route.query.id || sessionStorage.getItem("ORGANIZATION_ID"),
      }).then((res) => {
        this.pageLoading = false
        const { data } = res
        this.$router.push({
          query: {
            ...this.$route.query,
            id: data.id,
          }
        })
        this.orgInfo = data
        this.$store.commit('organization/setOrganizationInfo', data)
        sessionStorage.setItem('ORGANIZATION_ID', data.id)
        $Bus.$emit('pageHeaderTitle', data.name)
      })
    },
    login() {
      let baseUrl = ''
      if (process.env.VUE_APP_ENVIRONMENT === 'preview') {
        // 正式
        baseUrl = 'https://cloud.iquizoo.com/'
      } else if (process.env.VUE_APP_ENVIRONMENT === 'uat') {
        // 预发布
        baseUrl = 'http://cloud.uat.iquizoo.com/'
      } else {
        // 测试
        // baseUrl = 'http://cloud.alpha.iquizoo.com/'
        baseUrl = window.location.host.indexOf('localhost') != -1 ? `http://localhost:8000/` : 'http://cloud.alpha.iquizoo.com/'
      }
      const Url = baseUrl + 'jump?adminId=' + this.$store.getters['account/user'].id + '&orgId=' + this.orgInfo.id + '&orgType=' + this.orgInfo.orgType + '&orgName=' + this.orgInfo.name
      window.open(Url)
    },
  },
}
</script>

<style scoped lang="less">
.head-btn {
  position: absolute;
  top: -88px;
  right: 0;
  z-index: 10;
}
</style>
